/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2017, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import {
  Radio
} from '../'

export const RadioGroup = (props) => {
  let radiogroupId = props.id || Math.floor(Math.random() * 1000)
  return (
    <fieldset
      className={`slds-form-element${props.hasError ? " slds-has-error" : ''} ${props.className ? props.className: ''}`}
      style={props.style}>
      {props.label &&
        <legend className="slds-form-element__legend slds-form-element__label">
          {props.label}
        </legend>
      }
      <div className={`slds-form-element__control${props.horizontalDisplay ? " slds-list_horizontal" : ' '}${props.gridLayout ? "slds-grid" : ''}`}>
        {props.options.map((option, index) => (
          <Radio
            id={`${props.id}_${index}`}
            name={radiogroupId}
            label={option.label}
            onClick={props.onClick}
            value={props.booleanValues
              ? option.value.toString()
              : option.value
            }
            className={`${props.gridLayout
              ? `slds-size_1-of-${props.options.length}`
              : index === 0 ? '' : `slds-p-horizontal_${props.horizontalPadding}`}`
            }
            checked={props.booleanValues
              ? option.value.toString() === props.value.toString()
              : option.value == props.value}  // eslint-disable-line eqeqeq
            disabled={props.disabled}
            labelClassName={props.optionsLabelClassName}
            key={`radiogroup_${radiogroupId}_option_${index}`}
          />
        ))}
      </div>
      {props.hasError &&
        <div id="error_RadioGroup" className="slds-form-element__help">
          {props.errorMessage || "This field is required"}
        </div>
      }
    </fieldset>
  )
}

RadioGroup.defaultProps = {
  horizontalPadding: "none"
}

RadioGroup.propTypes = {
  id: PropTypes.string,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.element
    ]),
    label: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element
    ])
  })).isRequired,
  horizontalDisplay: PropTypes.bool,
  horizontalPadding: PropTypes.oneOf([
    "none",
    "xxx-small",
    "xx-small",
    "x-small",
    "small",
    "medium",
    "large",
    "x-large",
    "xx-large"
  ]),
  gridLayout: PropTypes.bool,  // effectively also a horizontal display of Radio buttons
  onClick: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
  errorMessage: PropTypes.string,
  booleanValues: PropTypes.bool,  // set to true if boolean option values need evaluating
  disabled: PropTypes.bool,
  className: PropTypes.string,
  optionsLabelClassName: PropTypes.string,
  style: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/radio-group/index.js